module.exports = __webpack_public_path__ + "img/default_cover_16_9.db676eae.png";